import { render, staticRenderFns } from "./CopyBlock.vue?vue&type=template&id=16568e1f&scoped=true"
import script from "./CopyBlock.vue?vue&type=script&lang=js"
export * from "./CopyBlock.vue?vue&type=script&lang=js"
import style0 from "./CopyBlock.vue?vue&type=style&index=0&id=16568e1f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0_n2ycmw2hd7odnkbow3ucmwrsku/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16568e1f",
  null
  
)

export default component.exports